export default "__VITE_ASSET__CGR3S5$C__"